export const API_PATHS = {
  auth: '/auth-application',
  database: (appId?: string) =>
    `/applications/${appId ?? ':appId'}/face-dbs/private`,
  setting: (appId?: string, dbId?: string) =>
    `/applications/${appId ?? ':appId'}/face-dbs/private/${
      dbId ?? ':dbId'
    }/roles`,
  face_id_detail: (id?: string) => `/face-ids/${id ?? ':id'}`,
  face_id: '/face-ids',
  get_avatar_image: (id?: string) => `/face-ids/${id ?? ':id'}/avatar`,
  get_face_image: (id?: string, faceId?: string) =>
    `/face-ids/${id ?? ':id'}/image/${faceId ?? ':faceId'}`,
  search_image: '/v1/users/image/search',
  search_verify_image: (id?: string) => `/face-ids/${id ?? ':id'}/verify`,
  face_id_search: '/face-ids/search',
  tag: '/v1/tag',
};
